module.exports = __webpack_public_path__ + "media/images/story/sample/sample-image-485d88598f22d419db661da2442ad2db.jpg";